import { useState } from 'react';
import { CountersPanel } from './CountersPanel';
import { ServicesPanel } from './ServicesPanel';
import { MappingMatrix } from './MappingMatrix';
import { SystemSettings } from './SystemSettings';
import { UsersPanel } from './UsersPanel';
import { MediaManager } from './MediaManager';
import { ReportingModule } from './ReportingModule';
import { StatsDashboard } from './StatsDashboard';

const NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: '◈' },
  { id: 'counters', label: 'Counters', icon: '⊞' },
  { id: 'services', label: 'Services', icon: '◉' },
  { id: 'mapping', label: 'Mapping Matrix', icon: '⊟' },
  { id: 'users', label: 'Users', icon: '👤' },
  { id: 'settings', label: 'Settings', icon: '⚙' },
  { id: 'media', label: 'Media / Ads', icon: '▷' },
  { id: 'reports', label: 'Reports', icon: '≡' },
];

const HAMBURGER_STYLE = {
  display: 'none', alignItems: 'center', justifyContent: 'center',
  width: 36, height: 36, border: 'none', borderRadius: 8,
  background: 'rgba(255,255,255,0.1)', color: '#fff', fontSize: 20, cursor: 'pointer',
  flexShrink: 0, transition: 'var(--transition)',
};

export default function AdminDashboard() {
  const [active, setActive] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const pages = {
    dashboard: <StatsDashboard />,
    counters: <CountersPanel />,
    services: <ServicesPanel />,
    mapping: <MappingMatrix />,
    users: <UsersPanel />,
    settings: <SystemSettings />,
    media: <MediaManager />,
    reports: <ReportingModule />,
  };

  const handleNav = (id) => {
    setActive(id);
    setSidebarOpen(false);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--navy)' }}>
      {/* Sidebar overlay (mobile) */}
      {sidebarOpen && (
        <div className="admin-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`} style={{
        width: 240, background: 'var(--navy)', flexShrink: 0, display: 'flex', flexDirection: 'column',
        borderRight: '1px solid rgba(255,255,255,0.07)', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100,
      }}>
        <div style={{ padding: '28px 24px 20px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 18, color: '#fff', letterSpacing: '-0.02em' }}>QMS</div>
            <div style={{ fontSize: 11, color: 'var(--cobalt-bright)', marginTop: 2, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Admin Console</div>
          </div>
          <button className="show-mobile" onClick={() => setSidebarOpen(false)}
            style={{ ...HAMBURGER_STYLE, display: 'none' }}>&#x2715;</button>
        </div>
        <nav style={{ flex: 1, padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {NAV.map(item => (
            <button key={item.id} onClick={() => handleNav(item.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '11px 14px',
                borderRadius: 'var(--radius-sm)', border: 'none', cursor: 'pointer', textAlign: 'left', width: '100%',
                fontFamily: 'var(--font-display)', fontWeight: active === item.id ? 700 : 500, fontSize: 13,
                transition: 'var(--transition)',
                background: active === item.id ? 'rgba(66,165,245,0.15)' : 'transparent',
                color: active === item.id ? 'var(--cobalt-bright)' : 'rgba(255,255,255,0.6)',
                borderLeft: active === item.id ? '3px solid var(--cobalt-bright)' : '3px solid transparent',
              }}>
              <span style={{ fontSize: 16 }}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>
        <div className="hide-mobile" style={{ padding: '16px 24px', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', fontFamily: 'var(--font-mono)' }}>v1.0.0 · QMS</div>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main" style={{ flex: 1, background: 'var(--off-white)', minHeight: '100vh' }}>
        <div style={{
          padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 12, minHeight: 56,
          borderBottom: '1px solid var(--gray-100)', background: '#fff',
        }} className="admin-topbar" >
          <button className="admin-hamburger" onClick={() => setSidebarOpen(true)}
            style={{ ...HAMBURGER_STYLE, background: 'var(--cobalt)', color: '#fff', borderRadius: 8, fontWeight: 700 }}>&#9776;</button>
          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 14, color: 'var(--gray-700)' }}>
            {NAV.find(n => n.id === active)?.label}
          </span>
        </div>
        <div className="admin-content" style={{ padding: '32px 40px', maxWidth: 1200 }}>
          {pages[active]}
        </div>
      </main>
    </div>
  );
}
